import React from "react";
import {
  FaArrowRight,
  FaDesktop,
  FaExternalLinkAlt,
  FaStopwatch,
} from "react-icons/fa";

function ScoreboardOnlineCard({ scoreboard }) {
  return (
    <article className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
      <div className="bg-gradient-to-br from-blue-700 via-indigo-700 to-sky-500 p-5 text-white sm:p-6">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-start lg:justify-between">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-2 text-xs font-bold uppercase tracking-[0.16em] text-white backdrop-blur-xl">
              <FaDesktop />
              {scoreboard.badge}
            </div>

            <h2 className="mt-4 font-titre text-3xl font-bold sm:text-4xl">
              {scoreboard.title}
            </h2>

            <p className="mt-2 text-sm font-bold uppercase tracking-[0.16em] text-white/55">
              {scoreboard.subtitle}
            </p>

            <p className="mt-4 max-w-2xl text-sm font-medium leading-7 text-white/80">
              {scoreboard.description}
            </p>
          </div>

          <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-[1.5rem] bg-white/15 text-3xl backdrop-blur-xl">
            <FaStopwatch />
          </div>
        </div>
      </div>

      <div className="grid gap-0 xl:grid-cols-[1fr_0.95fr]">
        <div className="p-4 sm:p-6">
          <div className="overflow-hidden rounded-[1.5rem] bg-slate-950 shadow-xl">
            <img
              src={scoreboard.image}
              alt={scoreboard.title}
              className="w-full object-cover"
            />
          </div>

          <p className="mt-4 text-xs font-bold uppercase tracking-[0.16em] text-slate-400">
            Aperçu
          </p>

          <h3 className="mt-1 font-titre text-xl font-bold text-slate-950 dark:text-white">
            Tableau de score Judo - Mode visiteurs
          </h3>

          <p className="mt-2 text-sm font-medium leading-6 text-slate-500 dark:text-white/50">
            Ippon, Waza-ari, Shido, Hansoku-make, Osaekomi, Golden Score :
            tout est prêt pour un affichage simple et rapide.
          </p>
        </div>

        <div className="flex flex-col justify-between p-4 sm:p-6">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.16em] text-blue-600 dark:text-blue-200">
              Pourquoi l'utiliser ?
            </p>

            <ul className="mt-4 space-y-3">
              {scoreboard.highlights.map((highlight) => (
                <li
                  key={highlight}
                  className="flex gap-3 text-sm font-medium leading-6 text-slate-600 dark:text-white/60"
                >
                  <span className="mt-1 h-2 w-2 shrink-0 rounded-full bg-blue-500" />
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-6 grid gap-2 sm:grid-cols-2 xl:grid-cols-1">
            <a
              href={scoreboard.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-blue-600 px-5 py-3 text-sm font-bold text-white transition hover:-translate-y-0.5 hover:bg-blue-700"
            >
              {scoreboard.primaryAction}
              <FaArrowRight />
            </a>

            <a
              href={scoreboard.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-5 py-3 text-sm font-bold text-slate-700 transition hover:-translate-y-0.5 hover:border-blue-200 hover:text-blue-700 dark:border-white/10 dark:bg-white/[0.05] dark:text-white"
            >
              Ouvrir dans un nouvel onglet
              <FaExternalLinkAlt />
            </a>
          </div>
        </div>
      </div>
    </article>
  );
}

export default ScoreboardOnlineCard;